import * as React from "react";
import { Create, SimpleForm, TextInput, BooleanInput, required, minLength, maxLength } from 'react-admin';
import { useTranslate } from 'ra-core';
import { TagListInput } from "./TagListInput";
import { TagGroupActions } from "./TagGroupActions";

export const TagGroupCreate = (props) =>  {
    const { basepath } = props;
    const translate = useTranslate();
    return (
        <Create {...props} actions={<TagGroupActions basePath={basepath}/>}>
            <SimpleForm>
                <TextInput source="name" label={translate(`cmss.resources.tag-group.fields.name`)} validate={[required(), minLength(3), maxLength(255)]} inputProps={{ size: 'medium' }} options={{ autoComplete: 'off' }} variant="outlined" />
                <BooleanInput source="mandatory_on_upload" label={translate(`cmss.resources.tag-group.fields.mandatory-on-upload`)} />
                <TagListInput source="tags"/>
            </SimpleForm>
        </Create>
    );
}